import { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import { ITokenInfo } from '@/request/token/token.response.interface';
import { useAppStore } from '@/store';

const DECIMAL_PLACES = 6;
const DEFAULT_PRICE = 0;

const formatPriceRatio = (value: BigNumber, decimals: number = DECIMAL_PLACES): string => {
  return value.isFinite() ? value.toFixed(decimals) : '0';
};

const createPriceRatioText = (amount: string, baseSymbol: string, quoteSymbol: string): string => {
  return `1 ${baseSymbol} ≈ ${amount} ${quoteSymbol}`;
};

export const useTokenPriceConversion = (solPrice: number | string, tokenInfo: ITokenInfo | undefined | null, isTransform: boolean) => {
  const { chainInfo } = useAppStore();
  return useMemo(() => {
    if (!tokenInfo?.price || !solPrice) {
      return isTransform ? `1 ${chainInfo.symbol} ≈ 0 ${tokenInfo?.symbol || ''}` : `1 ${tokenInfo?.symbol || ''} ≈ 0 ${chainInfo.symbol}`;
    }

    try {
      const tokenPrice = new BigNumber(tokenInfo.price || DEFAULT_PRICE);
      const solPriceBN = new BigNumber(solPrice);

      if (isTransform) {
        const solToToken = formatPriceRatio(solPriceBN.div(tokenPrice));
        return createPriceRatioText(solToToken, chainInfo.symbol, tokenInfo.symbol);
      } else {
        const tokenToSol = formatPriceRatio(tokenPrice.div(solPriceBN));
        return createPriceRatioText(tokenToSol, tokenInfo.symbol, chainInfo.symbol);
      }
    } catch (error) {
      return isTransform ? `1 ${chainInfo.symbol} ≈ 0 ${tokenInfo?.symbol}` : `1 ${tokenInfo?.symbol} ≈ 0 ${chainInfo.symbol}`;
    }
  }, [solPrice, tokenInfo, isTransform]);
};
